export default __webpack_public_path__ + "images/cd246a505edbdeb075edca0040311349.png";